import { useState } from 'react';
import { Button } from '@/components/ui/button';
import RetirementForm from './RetirementForm';
import { useAppContext } from '@/contexts/AppContext';

const Hero = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { heroVideo } = useAppContext();

  return (
    <>
      <section className="relative bg-gradient-to-br from-slate-700 via-slate-600 to-slate-800 text-white py-20 overflow-hidden">
        {/* Background Video */}
        {heroVideo && (
          <div className="absolute inset-0 z-0">
            <video 
              autoPlay 
              muted 
              loop 
              playsInline
              className="w-full h-full object-cover opacity-70"
              onError={(e) => {
                console.error('Video failed to load:', e);
              }}
            >
              <source src={heroVideo} type="video/mp4" />
            </video>
          </div>
        )}
        
        {/* Reduced Gradient Overlay - Made more transparent */}
        <div className="absolute inset-0 z-10 bg-gradient-to-br from-slate-700/40 via-slate-600/30 to-slate-800/50"></div>
        
        <div className="container mx-auto px-4 relative z-20">
          <div className="flex flex-col md:flex-row items-center justify-between max-w-6xl mx-auto">
            <div className="text-center md:text-left md:flex-1 mb-8 md:mb-0">
              <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white to-slate-100 bg-clip-text text-transparent drop-shadow-lg">
                Dan Casey
              </h1>
              <p className="text-xl md:text-2xl mb-4 text-white drop-shadow-md">
                Independent RIA and Fiduciary
              </p>
              <p className="text-base mb-6 text-slate-100 max-w-2xl drop-shadow-md">
                Dan is the founder of Bridgeriver Advisors. As a best-selling author and speaker, Dan is able to speak nationwide with his no nonsense brand of financial management. And as a pure fiduciary, he puts his clients interests first, helping them reach the retirement of their dreams.
              </p>
              <p className="text-base mb-8 text-slate-100 max-w-2xl drop-shadow-md">
                He simplifies the financial landscape so clients understand exactly where their money is and how it's effectively working for them with the lowest fees possible. It's not what you make - it's what you keep!
              </p>
              <Button 
                size="lg" 
                className="bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3 text-lg shadow-xl transform hover:scale-105 transition-all duration-200"
                onClick={() => setIsFormOpen(true)}
              >
                Find Out if You Have Enough Money to Last
              </Button>
            </div>
            <div className="md:flex-1 flex justify-center md:justify-end">
              <div className="relative">
                <div className="w-80 h-80 md:w-96 md:h-96 rounded-full overflow-hidden border-4 border-slate-400 shadow-2xl transform hover:scale-105 transition-all duration-300">
                  <img 
                    src="https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750633784318_a7e949a2.jpeg" 
                    alt="Dan Casey - Independent RIA"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <RetirementForm 
        isOpen={isFormOpen} 
        onClose={() => setIsFormOpen(false)} 
      />
    </>
  );
};

export default Hero;